<template>
  <div class="businessAdd">
    <div class="contentWrap" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 255, 255, 0.8)">
      <!-- 第一块 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>联系人信息</span> <span>该手机号即为核销登录手机号</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">联系人姓名</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="merchantUserRealname">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">联系人手机</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="merchantUserCellphone">
            </div>
          </div>
        </div>
      </div>
      <!-- 第2块 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>店铺信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">店铺名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeName">
            </div>
          </div>
          <b>{{addressArr}}</b>
          <div class="oneLine">
            <div class="label">店铺地址</div>
            <div class="rightInput">
              <!-- <el-cascader v-model="addressArr" placeholder="点击选择地址" :clearable="true"  ref="cascader"
              :props="props" @change="handleChangeAddress"></el-cascader> -->
              <el-cascader v-model="addressArr" :options="addressWordArr" placeholder="点击选择地址" :clearable="true" ref="cascader"
                @change="handleChangeAddress"></el-cascader>

              <input type="text" class="input" placeholder="请输入详细地址" v-model="addressString">
            </div>
            <br>
            <div class="label">精度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeLongitude">
            </div>
            <div class="label">维度</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="storeLatitude">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">地图插件</div>
            <div class="rightInput">
              <div id="mapContainer">
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">主营类目</div>
            <div class="rightInput">
              <el-cascader :options="optionsCategory" placeholder="点击选择类目" :clearable="true" v-model="mainCategoryArr"
                ref="cascaderCategory" @change="handleChangeCategory"></el-cascader>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">价格区间</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入开始" v-model="startPrice">-
              <input type="text" class="input" placeholder="请输入结束" v-model="endPrice">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">营业时间</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="openTime">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">所在园区</div>
            <div class="rightInput">
              <select name="" id="" v-model="itsLocation">
                <option :value="list.value" v-for="(list,index) in parkWord">{{list.text}}</option>
              </select>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店面照片</div>
            <div class="rightInput">
              <el-upload :on-remove="handleRemove" :name="'files'" :data="uploadData" :action="api.baseUrl+'/file/uploadfilebatch'"
                :on-success="addImgSuccessHandle" list-type="picture-card">
                <div class="mytriggerDiv" slot="trigger" @click="addImgClick('dianmian')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
              </el-upload>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店铺标签</div>
            <div class="rightInput">
              <div class="storeTagItem" v-for="(list,index) in list_tag_store" :class="{active:storeTag==list.tag_id}"
                @click="choseTag(list)">
                <img :src="list.tag_icon" alt="">
                <div class="text">{{list.tag_name}}</div>
              </div>


            </div>
          </div>

          <div class="oneLine">
            <div class="label">店铺介绍</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="parkDescribe">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店面地图显示图标：</div>
            <div class="rightInput">
              <div class="storeTagItem" v-for="(list,index) in list_tag_item" :class="{active:parkOnMapIcon==list.tag_id}"
                @click="choseTagMap(list)">
                <img :src="list.tag_icon" alt="">
                <div class="text">{{list.tag_name}}</div>
              </div>
            </div>
          </div>
          <div class="oneLine">
            <div class="label">店铺备注</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="parkRemark">
            </div>
          </div>
        </div>
      </div>
      <!-- 4 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>品牌信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">品牌名称</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="brandName">
            </div>
            <div class="label">所属公司</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入" v-model="byCompany">
            </div>
          </div>
          <div class="oneLine">
            <div class="label">品牌logo</div>
            <div class="rightInput">
              <el-upload :on-remove="handleRemove" :limit="1" :on-exceed="exceedHandle" :name="'files'" :data="uploadData"
                :action="api.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle" list-type="picture-card">
                <div class="mytriggerDiv" slot="trigger" @click="addImgClick('logo')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <!-- 5 -->
      <div class="panelBlock">
        <div class="panelTitle"><span>优惠信息</span></div>
        <div class="panelContent">
          <div class="oneLine">
            <div class="label">折扣</div>
            <div class="rightInput">
              <input type="text" class="input" placeholder="请输入折扣信息或其他优惠信息4个字以内" v-model="discountInfo">
            </div>
          </div>
        </div>
      </div>
      <!-- button -->
      <div class="btnBox">
        <el-button type='primary' @click="submitClick">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    json,
    wordData,
    utils
  } from '@/common/common.js'
  import {
    ajaxPost,
    api
  } from '@/common/request.js'
  import AMap from 'AMap'
  export default {
    name: 'adminIndex',
    data() {
      return {
        optionsCategory: [],
        isLoading: "",
        storeName: "",
        itsLocation: "",
        storeLongitude: "",
        storeLatitude: "",
        storeTag: "",
        parkOnMapIcon: '',
        merchantUserRealname: "",
        merchantUserCellphone: '',
        parkImg: '门店照片',
        mainCategoryArr: [],
        addressSelect: [],
        startPrice: "",
        list_tag_store: [],
        list_tag_item: [],
        endPrice: "",
        openTime: "",
        parkDescribe: "",
        parkWord: [],
        brandName: "",
        brandLogo: "",
        byCompany: "",
        addressArr: [],
        addressWordArr: [],
        discountInfo: "",
        parkRemark: "",
        storeId: '',
        mainCategory: [],
        //
        imageType: '',
        uploadData: {},
        dianmianImgInfoArr_string: '', //存储图片名字和其后台返回的id
        logoImgInfoArr_string: '', //存储图片名字和其后台返回的id

        // ditu
        proviceText: "",
        cityText: '',
        distText: '',
        proviceId: "",
        cityId: '',
        distId: '',
        addressString: '', //详细地址
        // props: {
        //   lazy: true,
        //   lazyLoad(node, resolve) {
        //     console.log(node)
        //     const {
        //       level
        //     } = node;
        //     let nodeId = node.value || 0
        //     let arg = {
        //       parentId: nodeId
        //     }
        //     ajaxPost('/globalRegionInfo/regionInfo', arg).then(function(res) {
        //       if (res.errorCode == 200) {
        //         let lists = res.data || [{
        //           region_id: node.value + 'mm',
        //           region_name: node.label
        //         }]
        //         // let lists=res.data
        //         let newArr = lists.map(function(item, index) {
        //           let buffer = {
        //             value: item.region_id,
        //             label: item.region_name,
        //             leaf: level >= 2,
        //           }
        //           return buffer
        //         })
        //         resolve(newArr);
        //       }
        //     }, function(res) {})

        //   }
        // }

      }
    },
    computed: {
      IMG_PREV() {
        return api.imgPrev
      },
      api() {
        return api
      },
      adminId() {
        return utils.getAdminId()
      },
    },
    components: {},
    methods: {
      exceedHandle() {
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        if (this.imageType == '11401') { //logo
          this.logoImgInfoArr_string = this.computeImgIdArrToString(fileList)
        }
        if (this.imageType == '11301') { //dianmian
          this.dianmianImgInfoArr_string = this.computeImgIdArrToString(fileList)
        }
      },
      computeImgIdArrToString(fileList) {
        let idArr = []
        for (var i = 0; i < fileList.length; i++) {
          let oneItem = fileList[i]
          let str = oneItem.wwId
          let arr = str.split(",")
          for (var j = 0; j < arr.length; j++) {
            let smallItem = arr[j]
            idArr.push(smallItem)
          }

        }
        return idArr.join(",")
      },
      turnImgIdToJson(str) {
        console.log(str)
        let result = ''
        if (str) {
          let arr = str.split(",")
          let newArr = arr.map(function(item, index) {
            return JSON.parse(item)
          })
          console.log(newArr)
          result = JSON.stringify(newArr)
        } else {
          result = ""
        }
        console.log(result)
        return result

      },
      addImgSuccessHandle(res, file, fileList) { //自动上传成功以后的操作
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);
        if (res.errorCode == 200) {
          file.wwId = res.data
          file.wwType = this.imageType
          if (this.imageType == '11401') { //logo
            this.logoImgInfoArr_string = this.computeImgIdArrToString(fileList)
          }
          if (this.imageType == '11301') { //dianmian
            this.dianmianImgInfoArr_string = this.computeImgIdArrToString(fileList)
          }
        }

      },
      addImgClick(type) { //点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---' + type)
        if (type == 'logo') {
          this.imageType = 11401
          this.uploadData = {
            imageType: this.imageType,
            imageUserId: this.adminId,
          }
          // console.log(this.uploadData)
        }
        if (type == 'dianmian') {
          this.imageType = 11301
          this.uploadData = {
            imageType: this.imageType,
            imageUserId: this.adminId,
          }
          // console.log(this.uploadData)
        }
      },
      choseTag(list) {
        this.storeTag = list.tag_id
      },
      choseTagMap(list) {
        this.parkOnMapIcon = list.tag_id
      },
      submitClick() {
        let _this = this
        let arg = {
          storeName: _this.storeName,
          itsLocation: _this.itsLocation,
          storeLongitude: _this.storeLongitude,
          storeLatitude: _this.storeLatitude,
          storeTag: _this.storeTag,
          parkOnMapIcon: _this.parkOnMapIcon,
          merchantUserRealname: _this.merchantUserRealname,
          merchantUserCellphone: _this.merchantUserCellphone,
          parkImg: _this.turnImgIdToJson(_this.dianmianImgInfoArr_string),
          mainCategory: _this.mainCategory,
          startPrice: _this.startPrice,
          endPrice: _this.endPrice,
          openTime: _this.openTime,
          parkDescribe: _this.parkDescribe,
          brandName: _this.brandName,
          brandLogo: _this.turnImgIdToJson(_this.logoImgInfoArr_string),
          byCompany: _this.byCompany,
          discountInfo: _this.discountInfo,
          parkRemark: _this.parkRemark,
          "regionProvinceId": _this.proviceId,
          "regionProvinceString": _this.proviceText,
          "regionCityId": _this.cityId,
          "regionCityString": _this.cityText,
          "regionDistrictId": _this.distId,
          "regionDistrictString": _this.distText,
          addressString: _this.addressString
        }
        console.log(arg)
        ajaxPost('/store/addStore', arg).then(function(res) {
          if (res.errorCode == 200) {
            alert("上传成功")

          } else {

          }
        }, function(res) {})

      },
      handleChangeCategory(value) {
        console.log(value)
        this.mainCategory = value ? value.join(",") : ''
      },
      getTagList(type) {
        let _this = this
        let arg = {
          tagType: type
        }
        ajaxPost('/tag/tagList', arg).then(function(res) {
          if (res.errorCode == 200) {
            let keyname = 'list_tag_' + type
            _this[keyname] = res.data

          } else {

          }
        }, function(res) {})
      },
      initMap() {
        let _this = this
        let map = new AMap.Map('mapContainer', {
          center: [120.275332, 30.357641],
          resizeEnable: true,
          zoom: 14,
          viewMode: '3D' //使用3D视图
        })
        AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function() {
          map.addControl(new AMap.ToolBar())
          map.addControl(new AMap.Scale())
        })
        let marker = ''
        map.on("click", function(ev) {
          var lnglat = ev.lnglat;
          var lng = ev.lnglat.getLng()
          var lat = ev.lnglat.getLat()
          _this.storeLongitude = lng //经度
          _this.storeLatitude = lat //维度
          map.remove(marker);
          marker = new AMap.Marker({
            position: new AMap.LngLat(lng, lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            // title: '北京'
          });
          // 将创建的点标记添加到已有的地图实例：
          map.add(marker);
        })
      },
      back() {
        this.$router.back()
      },
      // getAddressWord(arr) {
      //   arr = arr || []
      //   let _this = this
      //   let chosedProvice = arr[0]
      //   let chosedCity = arr[1]
      //   let chosedDist = arr[2]
      //   // 获取省的下拉字典
      //   let wordResult = []
      //   this.getAddressAjax(0, function(resDataWord) {
      //     wordResult = resDataWord

      //     // 假如选了一个，获取二级市区字典
      //     // alert(chosedProvice)
      //     if (chosedProvice) {
      //       _this.getAddressAjax(chosedProvice, function(resDataWord) {
      //         wordResult.forEach(function(item, index) {
      //           if (item.value == chosedProvice) {
      //             item.children = resDataWord
      //             console.log(wordResult)
      //             if (chosedCity) {
      //               _this.getAddressAjax(chosedCity, function(resDataWord2) {
      //                 wordResult[index].children.forEach(function(item2, index2) {
      //                   if (item2.value == chosedCity) {
      //                     item2.children = resDataWord2
      //                     console.log(wordResult)
      //                     return false
      //                   }
      //                 })
      //                 _this.addressWordArr=wordResult
      //               })
      //             }else{
      //               _this.addressWordArr=wordResult
      //             }
      //           }
      //         })
      //       })
      //     }else{
      //       _this.addressWordArr=wordResult
      //     }
      //   })
      // },
      getAddressWord() {
        let _this = this
        // 获取省的下拉字典
        let wordResult = []
        _this.getAddressAjax(0, function(resDataWord) {
          wordResult = resDataWord
          wordResult.forEach(function(item,index){
            _this.getAddressAjax(item.value,function(resDataWord1) {
              item.children = resDataWord1
              item.children.forEach(function(item2,index2){
                _this.getAddressAjax(item2.value,function(res2){
                  item2.children=res2
                  _this.addressWordArr=[]
                  _this.addressWordArr=wordResult
                })

              })

            })
          })

        })
      },
      getAddressAjax(parentId, callback) {
        ajaxPost('/globalRegionInfo/regionInfo', {
          parentId: parentId
        }).then(function(res) {
          if (res.errorCode == 200) {
            // addressWordArr
            let arr = res.data || []
            let resultArr = arr.map(function(item, index) {
              return {
                value: item.region_id,
                label: item.region_name,
                parent_id: item.parent_id
              }
            })
            callback && callback(resultArr)
          }
        }, function(res) {})
      },
      handleChangeAddress(value) { //更改地址
        console.log("地址change")
        console.log(value)
        // this.getAddressWord(value)
        // let nodesObj = this.$refs['cascader'].getCheckedNodes()
        // // console.log(nodesObj)
        // var valueArr = nodesObj[0].path
        // var TextArr = nodesObj[0].pathLabels
        // console.log(valueArr)
        // console.log(TextArr)
        // // proviceText
        // this.proviceId = valueArr[0]
        // this.cityId = valueArr[1]
        // this.distId = valueArr[2] && valueArr[2].length == 6 ? valueArr[2] : ''
        // this.proviceText = TextArr[0]
        // this.cityText = TextArr[1]
        // this.distText = this.distId ? TextArr[2] : ''
      },
      getParkWord() {
        let _this = this
        ajaxPost('/park/getParkList', {}).then(function(res) {
          if (res.data) {
            _this.parkWord = []
            _this.parkWord = res.data.map(function(item, index) {
              let buffer = {}
              buffer.value = item.park_id
              buffer.text = item.park_name
              return buffer
            })

          }
        }, function(res) {})
      },
      getCategoryWord() {
        let _this = this
        let args = {
          types: 1,
        }
        ajaxPost('/yijiajiaDataCategory/getDatasource', args).then(function(res) {
          if (res.data) {
            _this.optionsCategory = []
            var arr = res.data.product.list
            arr.forEach(function(item, index) {
              let obj = {
                value: item.dataName,
                label: item.dataName,
                children: []
              }
              var childArr = item.list
              childArr.forEach(function(item2, index2) {
                let childBuffer = {
                  value: item2,
                  label: item2,
                }
                obj.children.push(childBuffer)
              })
              _this.optionsCategory.push(obj)
            })


          }
        }, function(res) {})
      },
      getParam() {
        this.storeId = this.$route.params.id
      },
      getDetail() {
        let _this = this
        let args = {
          storeId: _this.storeId,
        }
        ajaxPost('/store/getStoreInfo', args).then(function(res) {
          if (res.data) {
            let resData = res.data
            _this.storeName = resData.storeName
            _this.itsLocation = resData.itsLocation
            _this.storeLongitude = resData.storeLongitude
            _this.storeLatitude = resData.storeLatitude
            _this.storeTag = resData.storeTag,
              _this.parkOnMapIcon = resData.parkOnMapIcon,
              _this.merchantUserRealname = resData.merchantUserRealname
            _this.merchantUserCellphone = resData.merchantUserCellphone
            if (resData.mainCategory) {
              _this.mainCategory = resData.mainCategory
              _this.mainCategoryArr = _this.mainCategory.split(",")
            }
            if (resData.priceRange) {
              let arr = resData.priceRange.split("-")
              _this.startPrice = arr[0]
              _this.endPrice = arr[1]
            }

            _this.openTime = resData.openTime
            _this.parkDescribe = resData.parkDescribe
            _this.brandName = resData.brandName
            _this.byCompany = resData.byCompany
            _this.discountInfo = resData.discountInfo
            _this.parkRemark = resData.parkRemark
            _this.proviceId = resData.regionProvinceId
            _this.addressString = resData.addressString
            _this.proviceText = resData.regionProvinceString
            _this.cityText = resData.regionCityString
            _this.cityId = resData.regionCityId
            _this.distId = resData.regionDistrictId
            _this.distText = resData.regionDistrictString
            _this.addressArr = []
            _this.addressArr.push(_this.proviceId)
            _this.addressArr.push(_this.cityId)
            if (_this.distId) {
              _this.addressArr.push(_this.distId)
            }
            _this.getAddressWord(_this.addressArr)
            // _this.handleChangeAddress(_this.addressArr)

            // parkImg: _this.turnImgIdToJson(_this.dianmianImgInfoArr_string),
            // brandLogo: _this.turnImgIdToJson(_this.logoImgInfoArr_string),
          }

        }, function(res) {})
      },

    },
    mounted() {
      let _this = this
      this.initMap()
      this.getParam()
      this.getCategoryWord()
      this.getParkWord()
      this.getTagList('store')
      this.getTagList('item') //这个换成地图
      this.getDetail()
    },
    destroyed() {

    }
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }

  #mapContainer {
    width: 600px;
    height: 280px;
  }

  .storeTagItem {
    border: 1px solid #ddd;
    padding: 5px;
    display: inline-block;
    margin-right: 5px;
    cursor: pointer;
    border-radius: 6px;

    img {
      width: 50px;
      height: 50px;
    }

    text-align: center;
  }

  .storeTagItem:hover,
  .storeTagItem.active {
    background: #ddfeff;
    border-color: blue;
    box-shadow: 0 0 3px #ddd;
  }

  .businessAdd {
    background: #fff;
    padding: 20px;
    padding-bottom: 100px;

    .panelBlock {
      .panelTitle {
        font-weight: bold;
        padding: 10px 0;
      }

      .panelContent {
        .oneLine {
          padding: 10px;

          .label {
            display: inline-block;
            padding: 0 20px;
          }

          .rightInput {
            display: inline-block;
          }
        }
      }
    }

    .btnBox {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/edit.vue